import CloseIcon from '@mui/icons-material/Close';
import { Box, Modal } from '@mui/material';

import { EmbeddedCheckout, EmbeddedCheckoutProvider } from '@stripe/react-stripe-js';
import { useEffect, useState } from 'react';

import { Color } from '../../constants';
import { stripePromise } from '../../lib/user/ useLoadStripe';
import { CreatePaymentResponse } from '../../lib/user/usePostPaymentIntent';
import { isMobile } from '../../lib/util/checkPlatform';

type SavePaymentModalProps = {
  paymentIntent: CreatePaymentResponse | null;
  onFinish?: () => void;
  onClose?: () => void;
};

const SavePaymentModal = ({ paymentIntent, onClose }: SavePaymentModalProps) => {
  const [prevStripe, setPrevStripe] = useState(stripePromise);
  useEffect(
    function () {
      setPrevStripe(stripePromise);
    },
    [stripePromise, prevStripe],
  );

  if (prevStripe !== stripePromise) return null;

  return (
    <Modal
      open={!!paymentIntent}
      onClose={onClose}
      aria-labelledby="stripe-payment-modal"
      aria-describedby="stripe-save-payment-info"
      sx={{
        display: 'flex',
        alignItems: isMobile() ? 'end' : 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          backgroundColor: '#ffffff',
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          ...(!isMobile() && { maxWidth: '400px' }),
          borderRadius: 4,
          padding: '10px',
          gap: '14px',
          maxHeight: isMobile() ? 'calc(90vh - 12px)' : '80vh',
          overflow: 'auto',
        }}
      >
        <CloseIcon
          onClick={onClose}
          sx={{
            alignSelf: 'flex-end',
            height: '24px',
            width: '24px',
            '&:hover': {
              backgroundColor: Color.ghostWhite,
            },
          }}
        />
        <EmbeddedCheckoutProvider
          stripe={stripePromise}
          options={{
            clientSecret: paymentIntent?.paymentIntent,
          }}
        >
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
      </Box>
    </Modal>
  );
};

export default SavePaymentModal;
